var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "subnet_header"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("Subnetwork")]), _c('h2', [_vm._v(_vm._s(_vm._f("subnet")(_vm.subnetID)))])]), _c('ContentMetadata', {
    attrs: {
      "total-blockchains": _vm.subnet.blockchains.length,
      "total-validators": _vm.subnet.validators.length,
      "total-delegators": _vm.subnet.delegators.length,
      "total-control-keys": _vm.subnet.controlKeys.length
    }
  }), _c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#validators"
    }
  }, [_vm._v("Validators")]), _c('v-tab', {
    attrs: {
      "href": "#pending-validators"
    }
  }, [_vm._v("Pending Validators")]), _c('v-tab', {
    attrs: {
      "href": "#blockchains"
    }
  }, [_vm._v("Blockchains")]), _c('v-tab', {
    attrs: {
      "href": "#control-keys"
    }
  }, [_vm._v("Control Keys")]), _c('v-tab', {
    attrs: {
      "href": "#delegations"
    }
  }, [_vm._v("Delegations")]), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "validators"
    }
  }, [_vm.subnet.validators.length === 0 ? [_c('p', {
    staticClass: "null"
  }, [_vm._v(" There are no validators for this subnet. ")])] : [_c('ValidatorDataTable', {
    staticClass: "table_margin",
    attrs: {
      "validators": _vm.subnet.validators,
      "subnet-i-d": _vm.subnetID,
      "subnet": _vm.subnet,
      "title": 'Validators'
    }
  })]], 2), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "pending-validators"
    }
  }, [_vm.subnet.pendingValidators.length === 0 ? [_c('p', {
    staticClass: "null"
  }, [_vm._v(" There are no pending validators for this subnet. ")])] : [_c('ValidatorDataTable', {
    staticClass: "table_margin",
    attrs: {
      "validators": _vm.subnet.pendingValidators,
      "subnet-i-d": _vm.subnetID,
      "subnet": _vm.subnet,
      "title": 'Pending Validators'
    }
  })]], 2), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "blockchains"
    }
  }, [_vm.subnet.blockchains.length === 0 ? [_c('p', {
    staticClass: "null"
  }, [_vm._v(" There are no blockchains for this subnet. ")])] : [_c('BlockchainDataTable', {
    staticClass: "table_margin",
    attrs: {
      "blockchains": _vm.subnet.blockchains,
      "title": 'Blockchains',
      "links": true
    }
  })]], 2), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "control-keys"
    }
  }, [_vm.subnet.controlKeys.length === 0 ? [_c('p', {
    staticClass: "null"
  }, [_vm._v(" There are no control keys for this subnet. ")])] : [_c('ControlKeyTable', {
    staticClass: "table_margin",
    attrs: {
      "subnet": _vm.subnet,
      "title": 'Control Keys'
    }
  })]], 2), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "delegations"
    }
  }, [_vm.subnet.delegators.length === 0 ? [_c('p', {
    staticClass: "null"
  }, [_vm._v(" There are no delegated stakes for this subnet. ")])] : [_c('DelegationDataTable', {
    staticClass: "table_margin",
    attrs: {
      "validators": _vm.subnet.delegators,
      "subnet-i-d": _vm.subnetID,
      "subnet": _vm.subnet,
      "title": 'Delegations'
    }
  })]], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }